import { useDispatch, useSelector } from "react-redux";
import {
  AnalyticsTypeMap,
  DATE_VIEW,
  FIXTURES_VIEW,
  LOCATION_MAP,
} from "../../../../constants";
import FilterSelection from "../../../../experiments/BubbleJourney/components/FilterSelection";
import styles from "./FilterDate.module.scss";
import {
  ADD_TO_FILTER_SELECTIONS,
  REMOVE_FROM_FILTER_SELECTIONS,
} from "../../../../constants/actions";
import { sendAnalyticsEvent } from "../../../../lib/postMessage";
import FilterSelectionLoadingSkeleton from "../../../../components/FilterSelectionLoadingSkeleton";
import { DESELECT, FILTERS, SELECT } from "../../../../constants/analytics";

export default function FilterDate() {
  const dispatch = useDispatch();
  const { prefetchedFilters } = useSelector((state) => state.filter);
  const { activeView } = useSelector((state) => state.view);
  const selections = [
    { type: "today", name: "Today" },
    { type: "tomorrow", name: "Tomorrow" },
  ];

  const handleFilterClick = (option) => {
    const analyticsEvent = {
      event: FILTERS,
      type: AnalyticsTypeMap.get(DATE_VIEW) ?? DATE_VIEW,
      location: LOCATION_MAP.get(activeView) || "",
    };
    if (prefetchedFilters.date.includes(option.type)) {
      dispatch({
        type: REMOVE_FROM_FILTER_SELECTIONS,
        payload: {
          filter: DATE_VIEW,
          type: option.type,
        },
      });
      // remove fixtures that have been selected from the deselected date
      if (prefetchedFilters.date.length === 2) {
        dispatch({
          type: "EMPTY_DATE_FIXTURES_FILTER_SELECTIONS",
          payload: {
            filter: FIXTURES_VIEW,
            date: option.type === "tomorrow" ? "tomorrow" : "today",
          },
        });
      }
      sendAnalyticsEvent({
        ...analyticsEvent,
        action: DESELECT,
        value: option.name,
      });
    } else {
      if (!prefetchedFilters.date.length) {
        // deselect fixtures that were previously selected when the user had no date filters selected
        dispatch({
          type: "EMPTY_DATE_FIXTURES_FILTER_SELECTIONS",
          payload: {
            filter: FIXTURES_VIEW,
            date: option.type === "tomorrow" ? "today" : "tomorrow",
          },
        });
      }
      dispatch({
        type: ADD_TO_FILTER_SELECTIONS,
        payload: {
          filter: DATE_VIEW,
          type: option.type,
        },
      });
      sendAnalyticsEvent({
        ...analyticsEvent,
        action: SELECT,
        value: option.name,
      });
    }
  };

  return (
    <div className={styles.dateSelections}>
      {selections.map((date) => (
        <FilterSelection
          key={date.type}
          onClick={() => handleFilterClick(date)}
          checked={prefetchedFilters.date.includes(date.type)}
          showCheckbox
          label={date.name}
        >
          <FilterSelectionLoadingSkeleton skeletonKey={date.type} />
          <div>
            <h4>{date.name}</h4>
            <p>{`Only show matches from ${date.type}`}</p>
          </div>
        </FilterSelection>
      ))}
    </div>
  );
}
